<div class="division-container container-fluid {{ brand.brandCssClass }}">
  <main class="row">
    @if ({ contacts: contacts$ | async, allDivisions: allDivisions$ | async }; as model) {
      <div class="division-form col-5">
        <div class="tasc-logo">
          <img [alt]="brand.companyName" src="assets/img/{{ brand.logoFileName }}" />
        </div>

        <div class="division-content">
          <h2 data-cy="welcome-contact">WELCOME {{ contactName }}</h2>

          <p data-cy="number-of-divisions-message">You support {{ numberOfDivisions }} divisions. Please select from the list below to continue.</p>

          <div data-cy="divisions-dropdown" class="division-select">
            <mat-form-field>
              <mat-label>Search divisions</mat-label>
              <mat-select data-cy="division-select" class="division-select" [disabled]="loading" [formControl]="selectedDivisionCtrl" tabindex="0" role="button" (keyup.enter)="$event.target.click()" #singleSelect>
                <div class="option-wrapper">
                  <mat-option>
                    <ngx-mat-select-search data-cy="division-search" [formControl]="divisionFilterCtrl" placeholderLabel="Search divisions" i18n-placeholderLabel i18n-noEntriesFoundLabel> </ngx-mat-select-search>
                  </mat-option>
                  @for (division of filteredDivisions; track division) {
                    <mat-option data-cy="division-name" class="division-name" [value]="division">
                      {{ division.divisionName }}
                    </mat-option>
                  }
                  @if (filteredDivisions?.length === 0) {
                    <mat-option [disabled]="true"> No results for "{{ divisionFilterCtrl.value }}." </mat-option>
                  }
                </div>
              </mat-select>
            </mat-form-field>
          </div>

          <button data-cy="continue-button" id="signInBtn" mat-flat-button [disabled]="!selectedDivisionCtrl.valid || loading" (click)="onDivisionSelect()" class="mat-primary btn-continue">
            Continue
            @if (loading) {
              <mat-spinner class="small-loader" diameter="20" strokeWidth="2"></mat-spinner>
            }
          </button>
        </div>
      </div>
    }
    <div class="col-7 welcome-section">
      <h1>WELCOME <br />TO {{ brand.companyName }}</h1>
    </div>
  </main>
</div>
